/* @ngInject */
function CampaignsAdminController ($scope, $translate, $q, ArtCollectionsService, ModalService) {
  const getCreateCampaignDialogController = () => $q.when(import('../../dialogs/create-campaign/create-campaign-dialog.controller'))

  $scope.listHeader = [
    { name: 'title', text: $translate.instant('title') },
    { name: 'createdAt', text: $translate.instant('creation') },
    { name: 'expirationDate', text: $translate.instant('expiration') },
    { name: 'groups', text: $translate.instant('groups') },
    { name: 'arts', text: $translate.instant('files') }
  ]

  $scope.top = 10
  $scope.tokensCount = 3
  $scope.visualization = 'thumb'
  $scope.selectedSort = {
    name: '',
    sort: ''
  }
  $scope.pageTitle = ''

  const api = {
    getCreateCampaignDialogController,
    _successGetCampaigns,
    _checkExpired,
    _handleGroups,
    _setHeader,
    _changeVisualization,
    activate
  }
  this.getApi = () => api

  api.activate()

  function activate () {
    api._setHeader($scope.visualization)
    ArtCollectionsService.getHighlightedCollections({ top: $scope.top, skip: 0, sort: $scope.selectedSort, adminView: true }).then(api._successGetCampaigns)
  }

  $translate.onReady(() => {
    $scope.pageTitle = $translate.instant('campaigns.title')
  })

  $scope.skipPagingTo = function (index) {
    ArtCollectionsService.getHighlightedCollections({ top: $scope.top, skip: $scope.top * index, sort: $scope.selectedSort, adminView: true }).then(api._successGetCampaigns)
  }

  $scope.openCampaignDialog = function (collection, highlighted) {
    api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      ModalService.showModal({
        templateId: 'createCampaign.html',
        templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        data: {
          collection,
          highlighted,
          isCreatingHighlightedCollection: true
        },
        controller: CreateCampaignDialogController
      }).then(wasUpdated => {
        if (wasUpdated) {
          api.activate()
        }
      })
    })
  }

  function _changeVisualization (type) {
    if ($scope.visualization === type) {
      return
    }
    $scope.visualization = type

    if (type === 'thumb') {
      $scope.selectedSort.name = ''
      $scope.selectedSort.order = ''
    }
    api.activate()
  }

  $scope.sortListClick = function (field) {
    if ($scope.selectedSort.name === field) {
      if ($scope.selectedSort.order === 'asc') {
        $scope.selectedSort.order = 'desc'
      } else if ($scope.selectedSort.order === 'desc') {
        $scope.selectedSort.order = ''
        $scope.selectedSort.name = ''
      }
    } else {
      $scope.selectedSort.name = field
      $scope.selectedSort.order = 'asc'
    }

    api.activate()
  }

  function _successGetCampaigns (data) {
    $scope.campaigns = data.rows
    $scope.count = data.count

    api._checkExpired($scope.campaigns)

    if ($scope.visualization === 'list') {
      api._handleGroups($scope.campaigns)
    }
  }

  function _checkExpired (campaigns) {
    const today = moment()

    campaigns.forEach(campaign => {
      if (moment(campaign.expirationDate) < today) {
        campaign.isExpired = true
      }
    })
  }

  function _handleGroups (campaigns) {
    campaigns.forEach(campaign => {
      if (campaign.groups.length <= 3) {
        campaign.groupList = campaign.groups
      } else {
        campaign.groupList = [
          campaign.groups[0],
          campaign.groups[1],
          campaign.groups[2],
          { name: `+ ${campaign.groups.length - 3}` }
        ]
      }
    })
  }

  function _setHeader (visualization) {
    const icon = visualization === 'thumb' ? 'menu' : 'grid'
    const param = visualization === 'thumb' ? 'list' : 'thumb'

    $scope.headerNavigation = {
      buttons: [{
        type: 'button',
        btnType: 'primary',
        label: $translate.instant('addFem'),
        icon: 'plus',
        onClick: $scope.openCampaignDialog
      }, {
        type: 'icon',
        icon,
        onClick: api._changeVisualization.bind(null, param)
      }]
    }
  }
}

export { CampaignsAdminController }
